import { render, staticRenderFns } from "./prepare-suggestions-table.vue?vue&type=template&id=d3f4ed3e&scoped=true"
import script from "./prepare-suggestions-table.vue?vue&type=script&lang=js"
export * from "./prepare-suggestions-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f4ed3e",
  null
  
)

export default component.exports